import React from 'react'
import './LoadingComponent.scss'

class LoadingComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			text: (props && props.text) || '正在加载中...'
		}
	}
	render() {
		const arr = [1, 2, 3, 4, 5, 6, 7, 8]
		return (
			<div className="loading-ctx">
				<div className="loading-module">
					<div className="loading-4">
						{
							arr.map((item, idx) => {
								return <i data-s={item} key={idx}></i>
							})
						}
					</div>
					<p className="loading-text">
						{ this.state.text }
					</p>
				</div>
			</div>
		);
	};
}

export default LoadingComponent;
